export default __webpack_public_path__ + "static/media/flanking.b1fc56dd.png";